export const ERROR_EMAIL = 'Invalid email'
export const ERROR_BLANK = "This field can't be blank"
